import script from "./RefuseDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./RefuseDialog.vue?vue&type=script&lang=ts&setup=true"

import "./RefuseDialog.vue?vue&type=style&index=0&id=c38d338c&lang=scss"
import "./RefuseDialog.vue?vue&type=style&index=1&id=c38d338c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c38d338c"]])

export default __exports__